import { AlarmSetup } from 'models/admin/Alarm';
import { CommonRequest, Method, ServiceName, CommonResponse } from 'models/common/RestApi';
import { callApi } from 'utils/ApiUtil';

export const getProjectAlarmList = async () => {
  const request: CommonRequest = {
    method: Method.GET,
    url: '/v1/setup/projectAlarm',
    serviceName: ServiceName.ELM_BE,
  };
  const response: CommonResponse<AlarmSetup[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as AlarmSetup[];
};

export const getProjectAlarmListCnt = async () => {
  const request: CommonRequest = {
    method: Method.GET,
    url: '/v1/setup/projectAlarmCnt',
    serviceName: ServiceName.ELM_BE,
  };
  const response: CommonResponse<number> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as number;
};
